import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReactNode } from "react";

import { TransactionContext } from "./TransactionContext";

import { instance } from "@/lib/axios/instance";
import { PagedResponse } from "@/types/response/PagedResponse";
import { TransactionType } from "@/types/transaction/TransactionType";

type TransactionProviderProps = {
  children: ReactNode;
  clientId?: string;
  descending?: boolean | null;
  orderBy?: string | null;
  page?: number;
  pageSize?: number;
};

export const TransactionProvider = ({
  children,
  clientId,
  descending = null,
  orderBy = null,
  page = 1,
  pageSize = 10,
}: TransactionProviderProps) => {
  const {
    data: transactions,
    isLoading: transactionsLoading,
    isFetching: transactionsFetching,
  }: UseQueryResult<PagedResponse<TransactionType>, AxiosError> = useQuery({
    queryKey: ["transactions", clientId, descending, orderBy, page, pageSize],
    queryFn: () =>
      instance
        .get<PagedResponse<TransactionType>>(`/api/v2/Transactions`, {
          params: {
            clientId,
            page,
            pageSize,
            orderBy,
            descending,
          },
        })
        .then((res) => res.data),
    enabled: !!clientId,
    // staleTime: 5 * 60 * 1000, // 5 minutes
  });
  return (
    <TransactionContext.Provider
      value={{
        transactions,
        transactionsLoading,
        transactionsFetching,
      }}
    >
      {children}
    </TransactionContext.Provider>
  );
};
